module.exports = __webpack_public_path__ + "media/images/icons/icon_instagram-f20ffcfaf8e0bb59d715a38c7584ad1f.svg";